module.exports = __webpack_public_path__ + "static/media/phone_iphone_white_24dp.30f88e47.svg";